import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import axios from "axios";
import DataTable from "react-data-table-component";
import iziToast from "izitoast";
import Counter from "./Counter";
import Footer from "./Footer";
import moment from "moment";
// import { SocketContext } from "../SocketContext";

export const UserDashboard = () => {
    // const { socket, connectSocket } = useContext(SocketContext);
    const navigate = useNavigate();
    const { logout, apipath } = useAuth();
    const userType = localStorage.getItem('userType');
    const userId = localStorage.getItem('studentId');
    const userData = localStorage.getItem('userData');
    const [tests, setTests] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const token = localStorage.getItem('token');
    const effectRan = useRef(false);
    if (!token || userType !== 'user') {
        logout();
    }

    const getTests = async () => {
        setIsLoading(true);
        try {
            const response = await axios.post(
                apipath + '/user_tests',
                {},
                {
                    headers: {
                        Authorization: 'Bearer ' + token
                    }
                }
            );
            console.log(response.data);
            if (response.data.status === "unauthentic") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                logout();
            }
            if (response.data.status === "false") {
                iziToast.error({
                    message: response.data.message,
                    position: "topCenter"
                });
                return false;
            }
            setTests(response.data.tests);
            setFilteredData(response.data.tests);

        }
        catch (error) {
            // console.error('Error fetching data:', error);
            if (error.status === 401) {
                iziToast.error({
                    message: "Un-Authorised! Please Login.",
                    position: "topCenter"
                });
                logout();
            }
            else {
                iziToast.error({
                    message: error,
                    position: 'topCenter'
                });
            }

        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (effectRan.current === false) {
            getTests();

            return () => {
                effectRan.current = true;
            };
        }
    }, []);

    // useEffect(() => {
        
    //         if (socket) {
    //             console.log('socket connection found');
    //             socket.emit('loggedin', {'token':token, 'room':'exam1'});
    //         }
    //         else {
    //             connectSocket(token);
    //         }
    // },[socket]);

    const startTest = () => {
        iziToast.success({
            'message': 'Start Test Button Clicked',
            position: 'topCenter',
        })
    }


    const [isVisible, setIsVisible] = useState(true);
    const starttime = (t) => {
        const mtime = new Date(t).toLocaleString();
        return mtime;
    }

    const columns = [
        { name: "Test Name", selector: (row) => row.test?.test?.test_name, sortable: true, },
        { name: "Exam", selector: (row) => row.user?.exam?.exam_name, sortable: true, },
        { name: "Organization", selector: (row) => row.user?.organization?.name, sortable: true, },
        { name: "Start Time", selector: (row) => moment(row.start_time).format("YYYY-MM-DD HH:mm"), sortable: true, },
        { name: "Start Test", selector: (row) => (row.status === 'submitted') ? <><button className="p-1 border rounded bg-orange-500">Submitted</button></> : <><Counter targetTime={row.start_time} testId={row.id} /></>, sortable: false, },
        // { name: "Add Questions", selector: (row) => <>
        //     {row.added_questions + "/" + row.total_questions} {(row.questions_left) ? <button onClick={()=>addQuestion(row.id, row.exam)} class="rounded p-1 cursor-pointer text-green-600 hover:text-white border-2 border-green-600 hover:bg-green-600">Add</button> : ""}
        //     </>, sortable: true, },
        // { name: "Status", selector: (row) => <>
        //     { (userType === 'admin') ? ((row.status === 'true') ? "Verified": "Un-Verified") : <input type="checkbox" onClick={() => testStatus(row.id)} checked={(row.status === 'true')} title={(row.status === "true") ? 'Active' : 'In-Active'} />}
        // </>, sortable: true, },
        // { name: "Action", selector: (row) => <>
        //         <i class="fa fa-eye rounded p-1 cursor-pointer text-green-600 hover:text-white border-2 border-green-600 hover:bg-green-600" title="view test" onClick={() => viewTest(row.id)}></i>
        //         <i class="fa fa-file rounded p-1 ml-1 cursor-pointer text-orange-500 hover:text-white border-2 border-orange-500 hover:bg-orange-500" title="attempt test" onClick={() => userTest(row.id)}></i>
        //         <i class="fa fa-edit rounded p-1 ml-1 cursor-pointer text-blue-600 hover:text-white border-2 border-blue-600 hover:bg-blue-600" title="edit test" onClick={() => editTest(row.id)}></i>
        //         <i class="fa fa-trash rounded p-1 ml-1 cursor-pointer text-red-600 hover:text-white border-2 border-red-600 hover:bg-red-600" title="delete test" onClick={() => deleteTest(row.id)}></i>
        //     </>, sortable: true,
        // },
    ];

    return (
        <>
            <span className={(isLoading) ? "flex items-center text-white bg-gray-400/75 justify-center fixed top-0 left-0 w-full h-screen z-50" : "hidden"}>
                <svg
                    className="w-5 h-5 mr-2 animate-spin"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                >
                    <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                    ></circle>
                    <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3V4a10 10 0 1010 10h-4l3 3 3-3h-4a8 8 0 01-8 8z"
                    ></path>
                </svg>
                Loading...
            </span>
            {<Navbar page={"studentdb"} />}
            <div class="flex flex-col md:flex-row">
                {/* {<Sidebar activePage={"exams"} />} */}
                <div class="main-content flex-1 bg-gray-100 pb-24 md:pb-5 w-full md:w-4/5 lg:w-5/6 pt-16 md:pt-8">

                    <div class="bg-teal-700 pt-4">
                        <div class=" bg-teal-600 p-4 justify-between shadow text-2xl text-white flex flex-col md:flex-row">
                            <span class="font-bold pl-2">Exams</span>
                            {/* <div className="flex flex-row mt-4 md:mt-0">
                                    <Link to={`/exams`}><span class={`md:ml-5 ml-2 ${activeTab === 'Exam' ? 'bg-blue-700 border-transparent' : 'bg-transparent border-white'} hover:bg-blue-700 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                        Exams
                                    </span></Link>
                                    <Link to={`/tests`}><span class={`md:ml-5 ml-2 ${activeTab === 'Test' ? 'bg-blue-700 border-transparent' : 'bg-transparent border-white'} hover:bg-blue-700 text-white font-medium text-base py-1 px-4 border hover:border-transparent rounded`}>
                                        Tests
                                    </span></Link>
                                </div> */}
                        </div>
                        {/* <div class="bg-gradient-to-r from-blue-700 to-blue-700 px-4 py-2 shadow text-base text-white">
                            <h3 class="font-medium pl-2">Users</h3>
                        </div> */}
                    </div>

                    <div class="flex flex-wrap ">
                        <div className="w-full p-2">
                            <div className="fluid mx-auto p-4" style={{ 'min-height': '75vh' }}>
                                <div class="mx-auto bg-white p-6 shadow-lg rounded-lg mb-3">
                                    <div class="flex justify-between items-center mb-4">
                                        <h2 class="text-2xl font-bold text-center flex-1" onClick={() => setIsVisible(!isVisible)}>Please Read the CBT Instructions</h2>
                                        <button id="toggle-btn" onClick={() => setIsVisible(!isVisible)} class="bg-teal-700 text-white p-2 rounded-md">{isVisible ? <>&#11165;</> : <>&#11167;</>}</button>
                                    </div>

                                    <div id="instructions" class={isVisible ? "block" : "hidden"}>
                                        <ol class="list-decimal list-inside space-y-4">
                                            <li>Total duration of examination in <span class="font-semibold">…….minutes</span>.</li>
                                            <li>The countdown timer in the top right corner of the screen will display the remaining time available for you to complete the examination. When the timer reaches zero, the examination will end by itself.</li>
                                            <li>
                                                The question palette displayed on the right side of the screen will show each question using one of the following symbols:
                                                <div class="mt-2 space-y-2">
                                                    <div class="flex items-center"><span class="border-2 rounded shadow-gray-600 shadow-sm border-red-600 w-4 h-4 mr-2"></span>You have not visited or answered the question yet.</div>
                                                    <div class="flex items-center"><span class="border-2 rounded shadow-gray-600 shadow-sm border-green-400 w-4 h-4 mr-2"></span>You have answered the question.</div>
                                                    <div class="flex items-center"><span class="border-2 rounded shadow-gray-600 shadow-sm border-yellow-400 w-4 h-4 mr-2"></span>You have not answered the question, but have marked it for review.</div>
                                                </div>
                                                <p class="mt-2">The "Marked for Review" status for a question simply indicates that you would like to look at the question again.</p>
                                            </li>
                                            <li>
                                                To navigate between questions within a Paper, candidates need to do the following:
                                                <ul class="list-disc list-inside mt-2 pl-4">
                                                    <li>Click on the question number in the Question Palette at the right of the screen to go to that numbered question directly. <span class="font-semibold">(Note: This does NOT save the answer to the currently displayed question.)</span></li>
                                                    <li>Click on <span class="font-semibold">“Save & Next”</span> to save the answer of any question. Clicking this will save the answer for the current question and display the next question.</li>
                                                    <li>Click on <span class="font-semibold">“Mark for Review & Next”</span> to mark a question for review (without answering it) and proceed to the next question.</li>
                                                </ul>
                                            </li>
                                        </ol>

                                        <h3 class="mt-6 text-lg font-bold">NOTE:</h3>
                                        <ul class="list-disc list-inside mt-2 pl-4 text-red-600 font-semibold">
                                            <li>Don’t click on the back arrow or forward arrow on the browser screen.</li>
                                            <li>Don’t close the window directly before clicking the <span className="bg-green-600 text-white px-1 rounded">Final Submit</span> button.</li>
                                            <li>Don’t refresh the page or browser.</li>
                                        </ul>
                                    </div>
                                </div>
                                {/* Data Table */}
                                <DataTable
                                    columns={columns}
                                    data={filteredData}
                                    // pagination
                                    highlightOnHover
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};